import { render } from "./ClientsPeriod.vue?vue&type=template&id=a951d6d2&scoped=true"
import script from "./ClientsPeriod.vue?vue&type=script&lang=js"
export * from "./ClientsPeriod.vue?vue&type=script&lang=js"

import "./ClientsPeriod.vue?vue&type=style&index=0&id=a951d6d2&scoped=true&lang=css"

import exportComponent from "C:\\PRO\\TimeSheet\\vue-cal-dev-ts-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a951d6d2"]])

export default __exports__